import { gql } from '@apollo/client';
// This feature is sharing same query together with PerformanceMetrics
export const getTranscriptSearchFilterQuery = gql `
  query performanceMetricsFilter($organizationID: ID!) {
    performanceMetricsFilter(organizationID: $organizationID) {
      protocolNames
    }
  }
`;
